<script>
	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";

	import PageSection from "../../components/PageSection.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";

	export let pageTitle = "Claim Transfer Information";
	export let lastVisitedPage = null;
	export let disabled = null;

	$model.registrationList = window.registrationList || [];
	console.log("registrationList", $model.registrationList);
	console.log("model", $model);
	console.log(window.registrationList);

	if (!disabled) {
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle + " | " + projectSettings.classActionName;
	}
</script>

<PageSection>
	<FormRow class="justify-content-center">
		<FormColumn>
			<h1 class="text-center">Stolen Wages NT Class Action Settlement</h1>
			<h2 class="text-center">Claim Transfer to Deloitte</h2>
		</FormColumn>
	</FormRow>

	<hr class="primary" />

	<FormRow class="justify-content-md-center">
		<FormColumn>
			<p>You have registered for the Stolen Wages NT Class Action Settlement.</p>
			<p>
				The following registration/s have been transferred to Deloitte, who are the Independent Administrators
				appointed by the Court. Deloitte are responsible for assessing your registration/s and determining if
				you will receive compensation.
			</p>

			{#if $model.registrationList && $model.registrationList.length > 0}
				<div class="table-responsive mt-4 mb-4">
					<table class="table table-striped table-bordered registration-table">
						<thead>
							<tr>
								<th>Registration Number</th>
								<th>Claim Type</th>
								<th>Worker Name</th>
							</tr>
						</thead>
						<tbody>
							{#each $model.registrationList as registration}
								<tr>
									<td>{registration.registrationNumber || "N/A"}</td>
									<td>{registration.claimType || "N/A"}</td>
									<td>{registration.worker || "N/A"}</td>
								</tr>
							{/each}
						</tbody>
					</table>
				</div>
			{:else}
				<p class="text-center text-muted mt-4 mb-4">No registrations found.</p>
			{/if}

			<p>
				Please contact Deloitte directly to speak to someone about these registrations or to provide any further
				supporting documentation:
			</p>
			<ul>
				<li><strong>Phone:</strong> 1800 371 231</li>
				<li>
					<strong>Email:</strong>
					<a href="mailto:ntstolenwages@deloitte.com.au">ntstolenwages@deloitte.com.au</a>
				</li>
				<li>
					<strong>Website:</strong>
					<a href="https://www.NTStolenWages.deloitte.com.au" target="_blank" rel="noopener noreferrer"
						>www.NTStolenWages.deloitte.com.au</a
					>
				</li>
			</ul>

			<p>
				If you have submitted multiple registrations, please note that only those listed above have been
				transferred to Deloitte. Shine is still reviewing any other registrations you may have.
			</p>

			<p>
				If you have any questions about any claims not listed above, you can call Shine for free on 1800 860
				378, or email us at <a href="mailto:ntstolenwages@shine.com.au">ntstolenwages@shine.com.au</a>.
			</p>
		</FormColumn>
	</FormRow>
</PageSection>

<style>
	h1 {
		margin-bottom: 0.5rem;
	}
	h2 {
		margin-bottom: 1.5rem;
		font-size: 1.5rem;
		color: var(--color-primary, #ff4814);
	}

	.registration-table {
		width: 100%;
		border-collapse: collapse;
		font-size: 0.9rem;
	}

	.registration-table th,
	.registration-table td {
		border: 1px solid #dee2e6;
		padding: 0.75rem;
		vertical-align: top;
		text-align: left;
	}

	.registration-table thead th {
		vertical-align: bottom;
		border-bottom: 2px solid #dee2e6;
		background-color: #f8f9fa;
		font-weight: bold;
	}

	.registration-table tbody tr:nth-of-type(odd) {
		background-color: rgba(0, 0, 0, 0.03);
	}

	.table-responsive {
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
	}

	ul {
		list-style: none;
		padding-left: 0;
	}

	ul li {
		margin-bottom: 0.5rem;
	}

	ul li strong {
		display: inline-block;
		width: 70px;
	}

	a {
		color: var(--color-primary, #ff4814);
	}

	a:hover {
		color: #cc3910;
	}
</style>
